/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFamilyMovieNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFamilyMovieNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Enjoy Movies Together!",
    "Family Movie Night Awaits!",
    "Cinematic Fun for Everyone!",
  ],
  title: "Family Movie Night",
  description: "Organize a fun family movie night.",
  longDescription:
    "Gather your family for an exciting movie night! Choose a date, decide on movies to watch, and plan snacks!",
  emoji: "🍿",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Family Movie Night",
          emoji: "🍿",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the family movie night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on movies to watch?",
            description: "What movies should we focus on during the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What movies should we consider?",
                emoji: "🎬",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we prepare for the movie night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🥨",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Movie Magic Begin!",
    outroDescription: "Your family movie night plans are set! Enjoy the show!",
  },
};
